// Auth
export const MAX_EMAIL_LENGTH = 254;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 128;
export const MAX_NAME_LENGTH = 64;

// Charities
export const MAX_CHARITY_NAME_LENGTH = 150;
export const MAX_CHARITY_LOGO_SIZE = 25;

// Businesses
export const MAX_BUSINESS_NAME_LENGTH = 150;
export const MAX_BUSINESS_CONTACT_NAME_LENGTH = 64;
export const MAX_BUSINESS_SUBDOMAIN_LENGTH = 60;
export const MAX_BUSINESS_LOGO_SIZE = 25;
export const MAX_BUSINESS_IFRAME_URL_LENGTH = 256;

// Directors
export const MAX_DIRECTOR_NAME_LENGTH = MAX_NAME_LENGTH;

// Funeral Notices/Memorials
export const MAX_MEMORIAL_SERVICE_IMAGE_SIZE = 25;
export const MAX_MEMORIAL_SERVICE_NAME_LENGTH = 64;
export const MAX_MEMORIAL_SERVICE_TYPE_LENGTH = 24;
export const MAX_MEMORIAL_SERVICE_LOCATION_LENGTH = 256;
export const MAX_MEMORIAL_SERVICE_PLOT_INFO_LENGTH = 256;
export const MAX_MEMORIAL_SERVICE_INFORMATION_LENGTH = 1024;
export const MAX_MEMORIAL_SERVICE_BOOK_FILE_SIZE = 25;

export const MAX_MEMORIAL_LOCATION_LENGTH = 128;
export const MAX_MEMORIAL_OBITUARY_LENGTH = 3000;
export const MIN_MEMORIAL_TIMELINE_YEAR = 0;
export const MAX_MEMORIAL_TIMELINE_YEAR = new Date().getFullYear();
export const MAX_MEMORIAL_TIMELINE_TITLE = 64;
export const MAX_MEMORIAL_TIMELINE_DESCRIPTION_LENGTH = 1024;
export const MAX_MEMORIAL_TIMELINE_IMAGE_SIZE = 25;
export const MAX_MEMORIAL_TIMELINE_VIDEO_SIZE = 75;
export const MAX_MEMORIAL_GALLERY_SECTION_NAME_LENGTH = 64;
export const MAX_MEMORIAL_GALLERY_SECTION_IMAGE_SIZE = 25;
export const MAX_MEMORIAL_GALLERY_SECTION_VIDEO_SIZE = 75;
export const MAX_MEMORIAL_GALLERY_SECTIONS = 10;
export const MAX_MEMORIAL_GALLERY_MEDIA = 250;
export const MAX_MEMORIAL_TIMELINE_ENTRIES = 30;
export const MAX_MEMORIAL_DURATION_LENGTH_SECONDS = 60;

// Support
export const MAX_SUPPORT_MESSAGE_LENGTH = 2048;
